module.exports = __webpack_public_path__ + "static/media/GroupMenuCenter.77b57e0d.png";